/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type AppointmentDtoType = (typeof AppointmentDtoType)[keyof typeof AppointmentDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppointmentDtoType = {
  BLOOD_SAMPLING: 'BLOOD_SAMPLING',
  XRAY: 'XRAY',
  TUBERCULIN: 'TUBERCULIN',
  SPUTUM: 'SPUTUM',
  OTHER: 'OTHER',
} as const;
